import styled, { css } from 'styled-components';
import NewButton from '../components/common/button/NewButton';
import { fontFamily } from '../components/common/typography/Typography';

export const ProfileContainer = styled.div`
  margin: auto;
  width: 1200px;
`;

export const MypageContainer = styled.div`
  background-color: ${props => props.theme.palette.black};
  color: ${props => props.theme.palette.white};
  padding: ${props => `${props.theme.spacing(20)} 0`};
  & > div:not(:last-of-type) {
    margin-bottom: ${props => props.theme.spacing(15)};
  }
`;

export const TitleWrap = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing(4)};
  margin-bottom: ${props => props.theme.spacing(3)};
  & .text-button {
    cursor: pointer;
  }
`;

export const MainVideoSelectBox = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${props => props.theme.spacing(4)};
  gap: ${props => props.theme.spacing(3)};
`;

export const ProfileEditContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.black};
  color: ${({ theme }) => theme.palette.white};
  margin: auto;
  padding-top: ${({ theme }) => theme.spacing(16)};
  padding-bottom: ${({ theme }) => theme.spacing(24)};
  & > div:not(:last-of-type) {
    margin-bottom: ${({ theme }) => theme.spacing(15)};
  }
`;

/**
 * -------------------------------------
 *          My Page - Payment
 * -------------------------------------
 */
export const PaymentContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.black};
  color: ${({ theme }) => theme.palette.white};
  margin: auto;
  & > div:not(:last-of-type) {
    margin-bottom: ${({ theme }) => theme.spacing(15)};
  }
`;

export const PayeeInputGrid = styled.div`
  display: grid;
  grid-template-rows: repeat(4, 1fr);
  grid-template-columns: 0fr 1fr 1fr;
  /* grid-auto-rows: 100px; */
  grid-row-gap: ${props => props.theme.spacing(4)};
  grid-column-gap: ${props => props.theme.spacing(5)};
  & > div:first-of-type {
    grid-row-start: 1;
    grid-row-end: 5;
  }
  & > div:last-of-type {
    grid-column-start: 2;
    grid-column-end: 4;
    display: flex;
    flex-direction: column;
    gap: ${props => props.theme.spacing(2)};
  }
  ${props =>
    props.type === 1
      ? css``
      : css`
          & > div:nth-of-type(2) {
            /* grid-column: 2 / span 2;
            width: ${props => `calc(50% - ${props.theme.spacing(2.5)})`}; */
          }
        `};
`;

export const ReqChangeRemitteeGrid = styled.div`
  display: flex;
  /* grid-template-rows: repeat(4, 1fr);
  grid-template-columns: 1fr 3.2fr;
  grid-row-gap: ${props => props.theme.spacing(5)};
  & > div:first-of-type {
    grid-row-start: 1;
    grid-row-end: 5;
  } */
  & > div:first-of-type {
    padding: ${({ theme }) => theme.spacing(0, 8)};
  }
  & > div:last-of-type {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(5)};
  }
`;

export const TextBox = styled.div`
  border-radius: 10px;
  background-color: ${props => props.theme.palette.darkgray2};
  color: ${props => props.theme.palette.white};
  padding: ${props => `${props.theme.spacing(4)} ${props.theme.spacing(6)}`};
`;

export const MinimumPaymentsText = styled.p`
  ${fontFamily};
  font-weight: 400;
  font-size: ${props => props.theme.fontSize['24']};
  line-height: 36px;
  margin: 0;
`;

export const SettlementInfoContents = styled.div`
  ${fontFamily};
  background-color: ${props => props.theme.palette.darkgray};
  color: ${props => props.theme.dim['60_white']};
  border-radius: 5px;
  padding: ${props => props.theme.spacing(6, 10)};
  white-space: pre-wrap;
  & > ul {
    margin: 0;
    padding-left: 1em;
    & > li.highlighted-list-item {
      color: ${({ theme }) => theme.palette.primary.main};
    }
  }
`;

export const PaymentButton = styled(NewButton).attrs(props => ({
  shape: 'rectangle',
  variant: 'outlined',
  color: 'secondary',
  size: 'sm',
}))`
  font-size: ${({ theme }) => theme.fontSize['14']};
  font-weight: normal;
  height: 26px;
  border-radius: 4px;
  padding: ${({ theme }) => theme.spacing(1, 3)};
  border-color: #888;
`;
